import { createSlice } from '@reduxjs/toolkit'

import { expireSession } from '../auth/actions'

interface CreditsTopUpState {
  isOpen: boolean
}

const initialState: CreditsTopUpState = {
  isOpen: false,
}

const creditsTopUpSlice = createSlice({
  name: 'creditsTopUp',
  initialState,
  reducers: {
    openCreditsTopUp: (state) => {
      state.isOpen = true
    },
    closeCreditsTopUp: (state) => {
      state.isOpen = false
    },
  },
  extraReducers: (builder) => builder.addCase(expireSession, () => initialState),
})

export const { openCreditsTopUp, closeCreditsTopUp } = creditsTopUpSlice.actions

export const selectIsCreditsTopUpOpen = (state: { creditsTopUp: CreditsTopUpState }): boolean =>
  state.creditsTopUp.isOpen

export default creditsTopUpSlice.reducer
